import React from "react";
import LoadingIcon from "../Icons/Loading";
import CheckCircleIcon from "../Icons/CheckCircle";
import CancelCircleIcon from "../Icons/CancelCircle";
import { InfoStatusTypesPropTypes, InfoStatusTypes } from "./InfoStatusPropTypes";
const InfoStatusIcon = ({ type }) => {
    switch (type) {
        case InfoStatusTypes.loading:
            return React.createElement(LoadingIcon, { "data-testid": "loadingIcon" });
        case InfoStatusTypes.cancelled:
            return React.createElement(CancelCircleIcon, { "data-testid": "cancelIcon" });
        case InfoStatusTypes.submitted:
            return React.createElement(CheckCircleIcon, { "data-testid": "checkIcon" });
        default:
            return React.createElement(LoadingIcon, { "data-testid": "loadingIcon" });
    }
};
InfoStatusIcon.propTypes = {
    type: InfoStatusTypesPropTypes,
};
export default InfoStatusIcon;
//# sourceMappingURL=InfoStatusIcon.js.map